import Vue from 'vue'
import App from './App.vue'
import router from './misc/router'
import store from './misc/store'
import './misc/global';
import './misc/translation';
import config from './config';
import vuetify from './misc/vuetify';
import Auth from './misc/auth';
import moment from 'moment-timezone';
import VueMeta from 'vue-meta';
import "./styles/styles.css";
import './misc/axios';
require('moment/locale/es');
Vue.config.productionTip = false
Vue.prototype.$env = {
  api: config.api,
  pathImg: config.pathImg,
  appName: config.appName
};
Vue.use(Auth);
Vue.use(require('vue-moment'),{ 
  moment
});
Vue.use(VueMeta, {
  keyName: 'head'
})

new Vue({
  router,
  store,
  vuetify,
  render: h => h(App)
}).$mount('#app')